import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BreadCrumbs from '../../components/BreadСrumbs/BreadСrumbs';
import {
  GetCategoriesList,
  GetTopicsByCategory,
  ForumSearch,
} from '../../utils/api/services/forum.js';
import paths from '../../paths';
import TopicListItem from './TopicListItem';
import Preloader from '../../components/Preloader/Preloader';
import ListFooter from '../../components/ListFooter/ListFooter';
import ForumTopicListHeader from './ForumTopicListHeader';
import ForumHeaderMobile from './ForumHeaderMobile';
import ForumHeaderDesktop from './ForumHeaderDesktop';
import ForumSearchBlock from './ForumSearchBlock';
import { setUrlParameters } from '../../utils/helpers';
import { getPage, getQuery } from '../../utils/urlHelper';

export default class ForumTopicList extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    this.pageSize = 15;

    this.state = {
      categories: [],
      topicList: [],
      searchQuery: getQuery(),
      searchResult: [],
      searchTotal: 0,
      isLoading: true,
      isLoadingMore: false,
      total: 0,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setResult();
    }
  }

  componentWillMount = () => {
    this.getCategories();
  };

  getCategories = () => {
    this.setState({ isLoading: true });
    GetCategoriesList()
      .then((result) => {
        this.setState({ categories: result }, this.setResult);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * @param {bool}  more   добавлять новые темы в список, а не перетирать их.
   */
  getTopicsByCategory = (id, take = 15, skip = 0, more = false) => {
    if (more) {
      this.setState({ isLoadingMore: true });
    } else {
      this.setState({ isLoading: true });
    }
    GetTopicsByCategory(id, take, skip)
      .then((result) => {
        if (more) {
          this.setState({
            topicList: [...this.state.topicList, ...result.data],
            total: result.total,
          });
        } else {
          this.setState({
            topicList: result.data,
            total: result.total,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingMore: false,
        });
      });
  };

  getSelectedCategory = () => {
    if (!this.state.categories || !this.state.categories.length) {
      return {};
    }

    const categoryFromUrl = this.state.categories.find(
      item => item.alias === this.props.match.params.alias,
    );

    return categoryFromUrl || this.state.categories[0];
  };

  setResult = (more = false) => {
    const page = getPage();
    const query = getQuery();
    const selectedCategory = this.getSelectedCategory();

    if (query) {
      this.search(
        query,
        'category',
        selectedCategory.alias,
        this.pageSize,
        (page - 1) * this.pageSize,
        more,
      );
    } else {
      this.getTopicsByCategory(
        selectedCategory.alias,
        this.pageSize,
        (page - 1) * this.pageSize,
        more,
      );
    }
  };

  handleSelectedCategoryChange = (selectedCategory) => {
    this.setState({ searchQuery: '' }, this.setResult);
    this.props.history.push(`${paths.advocates.forumCategories}/${selectedCategory.alias}`);
  };

  handleSearchQueryChange = (e) => {
    const searchQuery = e.currentTarget.value;
    this.setState({ searchQuery });
  };

  search = (query, type, alias, take, skip, more) => {
    ForumSearch(query, type, alias, take, skip)
      .then((result) => {
        this.setState(
          {
            searchResult: more ? [...this.state.searchResult, ...result.data] : result.data,
            searchTotal: result.total,
          },
          this.fetchData,
        );
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          isLoadingMore: false,
        });
      });
  };

  setQueryUrl(query, page, callback) {
    const urlQuery = {};
    urlQuery.page = page > 1 ? page : null;
    urlQuery.query = query;
    setUrlParameters(urlQuery, callback);
  }

  handleSearch = () => {
    this.setQueryUrl(
      this.state.searchQuery,
      null,
      this.setState({ searchTotal: null }, this.setResult),
    );
  };

  handleSearchEnterPress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      this.handleSearch();
    }
  };

  handlePageClick = (e) => {
    const newPage = e.selected + 1;
    this.setQueryUrl(getQuery(), newPage, this.setResult);
  };

  handleGetMoreTopics = () => {
    this.setQueryUrl(
      getQuery(),
      getPage() + 1,
      this.setState({ isLoadingMore: true }, () => this.setResult(true)),
    );
  };

  render() {
    const {
      categories,
      searchQuery,
      searchResult,
      searchTotal,
      topicList,
      total,
      isLoading,
      isLoadingMore,
    } = this.state;

    const page = getPage();
    const requestedSearchQuery = getQuery();
    const selectedCategory = this.getSelectedCategory();

    return (
      <div className="b-center bg-dragonfly5">
        <BreadCrumbs
          data={[
            { url: paths.advocates.main, text: 'Главная' },
            { url: paths.advocates.forum, text: 'Форум' },
            {
              url: `${paths.advocates.forumCategories}/${selectedCategory.alias}`,
              text: selectedCategory.title,
            },
          ]}
        />
        <h1 className="title -third">Форум</h1>

        <ForumHeaderDesktop
          categories={categories}
          selectedCategory={selectedCategory}
          searchQuery={searchQuery}
          handleSearchQueryChange={this.handleSearchQueryChange}
          handleSearch={this.handleSearch}
          handleSearchEnterPress={this.handleSearchEnterPress}
          handleSelectedCategoryChange={this.handleSelectedCategoryChange}
          renderSearchButton
          renderDropdown
        >
          <Link
            to={`${paths.advocates.forumNewTopic}/${selectedCategory.alias}`}
            className="btn themes-search__button"
          >

            Создать тему
          </Link>
        </ForumHeaderDesktop>
        <ForumHeaderMobile
          categories={categories}
          selectedCategory={selectedCategory}
          searchQuery={searchQuery}
          handleSearchQueryChange={this.handleSearchQueryChange}
          handleSearch={this.handleSearch}
          handleSearchEnterPress={this.handleSearchEnterPress}
          handleSelectedCategoryChange={this.handleSelectedCategoryChange}
        />
        {requestedSearchQuery ? (
          <ForumSearchBlock searchQuery={requestedSearchQuery} searchResult={searchResult} />
        ) : (
          <div className="themes-list themes-list--all">
            {isLoading ? (
              <Preloader />
            ) : topicList.length ? (
              topicList.map(item => <TopicListItem key={item.id} topic={item} />)
            ) : (
              'В этом разделе еще нет тем'
            )}
            {isLoadingMore && <Preloader />}
          </div>
        )}

        <div className="mobile-show">
          <Link
            to={`${paths.advocates.forumCategories}/${selectedCategory.alias}`}
            className="btn w100pr"
            onClick={this.handleCreateTopic}
          >

            Создать тему
          </Link>
        </div>
        <ListFooter
          counterLabel="тем"
          pageSize={this.pageSize}
          total={requestedSearchQuery ? searchTotal : total}
          handlePageClick={this.handlePageClick}
          handleLoadMore={this.handleGetMoreTopics}
          currentPage={page}
        />
      </div>
    );
  }
}
